// Bags&Me card cart: add / + / - without a page refresh, kept in sync with Horizon's header bubble and cart drawer.
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
let cartCache = null;

function request(path, body) {
  return fetch(ROOT + path, {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  }).then(function (res) {
    return res.json().then(function (json) {
      if (!res.ok || json.status) throw json;
      return json;
    });
  });
}

function getCart() {
  return request('cart.js').then(function (cart) {
    cartCache = cart;
    return cart;
  });
}

function qtyFor(cart, variantId) {
  return cart.items.reduce(function (sum, item) {
    return String(item.variant_id) === String(variantId) ? sum + item.quantity : sum;
  }, 0);
}

function lineKey(cart, variantId) {
  const line = cart && cart.items.find(function (item) { return String(item.variant_id) === String(variantId); });
  return line ? line.key : '';
}

function paint(card, qty) {
  const add = card.querySelector('[data-bm-add]');
  const stepper = card.querySelector('[data-bm-qty]');
  const count = card.querySelector('[data-bm-count]');
  if (!add || !stepper) return;
  add.hidden = qty > 0;
  stepper.hidden = qty === 0;
  if (count) count.textContent = String(qty);
}

function sync(cart) {
  document.querySelectorAll('[data-bm-card]').forEach(function (card) {
    paint(card, qtyFor(cart, card.dataset.variant));
  });
}

function announce(card, action, lines) {
  const deferred = CartLinesUpdateEvent.createPromise();
  card.dispatchEvent(new CartLinesUpdateEvent({ action: action, context: 'product', lines: lines, promise: deferred.promise }));
  return deferred;
}

function settle(deferred, cart) {
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: { items: cart.items, itemCount: cart.item_count, source: 'bm-card' },
  });
}

function run(card, action, lines, call) {
  const msg = card.querySelector('[data-bm-msg]');
  if (msg) msg.textContent = '';
  card.classList.add('is-busy');
  const deferred = announce(card, action, lines);
  return call()
    .then(getCart)
    .then(function (cart) {
      sync(cart);
      settle(deferred, cart);
    })
    .catch(function (err) {
      if (msg) msg.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
      getCart().then(function (cart) {
        sync(cart);
        settle(deferred, cart);
      }).catch(function () { deferred.reject(err); });
    })
    .finally(function () { card.classList.remove('is-busy'); });
}

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-bm-add],[data-bm-inc],[data-bm-dec]');
  if (!button) return;
  const card = button.closest('[data-bm-card]');
  if (!card || card.classList.contains('is-busy')) return;
  event.preventDefault();
  const variantId = card.dataset.variant;
  const current = Number((card.querySelector('[data-bm-count]') || {}).textContent) || 0;

  if (button.hasAttribute('data-bm-add')) {
    run(card, 'add', [{ merchandiseId: String(variantId), quantity: 1 }], function () {
      return request('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
    });
    return;
  }

  const next = Math.max(0, current + (button.hasAttribute('data-bm-inc') ? 1 : -1));
  const key = lineKey(cartCache, variantId);
  run(card, next > 0 ? 'update' : 'remove', [{ id: key, quantity: next }], function () {
    return request('cart/change.js', key ? { id: key, quantity: next } : { id: String(variantId), quantity: next });
  });
});

// Changes made in the cart drawer or on the product form update the cards too.
document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
  if (event.target && event.target.closest && event.target.closest('[data-bm-card]')) return;
  if (!event.promise) return;
  event.promise.then(function () { return getCart(); }).then(sync).catch(function () {});
});

window.addEventListener('pageshow', function () {
  if (document.querySelector('[data-bm-card]')) getCart().then(sync).catch(function () {});
});

if (document.querySelector('[data-bm-card]')) getCart().then(sync).catch(function () {});
